import React from 'react'
import { DownOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import { Menu, Dropdown } from 'antd'
import { connect } from 'react-redux'
import Cookies from 'js-cookie'
import { actionCreators } from '@/store'
import { TOKEN_KEY } from '../../constants'
import './style.scss'
import {goPentagon} from '../../util/get-env'

function Header(props) {
  const { menuCollapsed, setMenuCollapsed, setLoginStatus, loginUser, personalize } = props
  const logout = async() => {
    if (!personalize.domain && (window.location.href.indexOf('netbox.simboss.com') > -1)) {
      Cookies.remove(TOKEN_KEY)
      goPentagon()
      return
    }
    Cookies.remove(TOKEN_KEY)
    setLoginStatus(false)
  }

  const menu = (
    <Menu>
      <Menu.Item>
        <span onClick={logout}>
          退出系统
        </span>
      </Menu.Item>
    </Menu>
  )

  return (
    <div className="app-header">
      <div className="collapse" onClick={setMenuCollapsed}>
        {menuCollapsed ? (<MenuUnfoldOutlined/>) : (<MenuFoldOutlined/>)}
      </div>
      <div className="header-menu">
        {loginUser && loginUser.isLevel1Customer && (
          <a target="_blank" href="https://www.yuque.com/books/share/4eeabb72-f0c1-4133-80c0-da3e422d3b1e/ymuc2q">帮助文档</a>
        )}
      </div>
      <div className="account">
        <Dropdown overlay={menu}>
          <div className="name">{loginUser.orgName} <DownOutlined/></div>
        </Dropdown>
      </div>
    </div>
  )
}

export default connect(state => ({
  menuCollapsed: state.getIn(['common', 'menuCollapsed']),
  loginUser: state.getIn(['common', 'loginUser']),
  personalize: state.getIn(['common', 'personalize'])
}), dispatch => ({
  setMenuCollapsed() {
    dispatch(actionCreators.setMenuCollapsed())
  },
  setLoginStatus(value) {
    dispatch(actionCreators.setLoginStatus(value))
  }
}))(Header)
